import { render, staticRenderFns } from "./TheCtiList.vue?vue&type=template&id=2f519581&"
import script from "./TheCtiList.vue?vue&type=script&lang=js&"
export * from "./TheCtiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports